"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondInvoiceResponse = exports.basicInvoiceResponse = exports.secondInvoice = exports.basicInvoice = void 0;
exports.basicInvoice = {
    guid: "invoice guid here",
    type: "assembled",
    date_of_service: "2019-02-12",
    datetime_of_service: "2019-02-12T18:44:05.161-0500",
    point_of_care: "",
    place_of_service: "CMX Radiology-500 Main St",
    billing_location: "Outpatient",
    billing_area: "CMX IMAGING",
    billing_provider_specialty: "Radiology",
    billing_provider_name: "DUNHAM MD,SALLY V",
    billing_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    billing_provider_assistant_name: "Resident, Some",
    billing_provider_assistant_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    ordering_provider_name: "HAMILTON MD,GEORGE",
    ordering_provider_specialty: "Family Medicine",
    ordering_provider_number: {
        number: "45670",
        issuer: "EPIC",
        type: "UPN"
    },
    referring_provider_specialty: "Radiology",
    referring_provider_name: "DUNHAM MD,SALLY V",
    referring_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    rendering_provider_specialty: "Radiology",
    rendering_provider_name: "DUNHAM MD,SALLY V",
    rendering_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    performing_provider_specialty: "Radiology",
    performing_provider_name: "DUNHAM MD,SALLY V",
    performing_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    transactions: [
        {
            type: "SUBMITTED",
            guid: "transaction guid here",
            transaction_type: "CHARGE",
            transaction_id: "CMX-MGPO-Billing-3",
            transaction_code: "1003001052088346",
            transaction_batch_id: "CMX-MGPO-Billing-3",
            transaction_posting_date: "2020-02-20T18:44:05.161-0500",
            transaction_description: "C4d Complement (immunofluorescence) - BW",
            alt_transaction_description: "",
            department_code: "10030010520",
            fee_schedule: "5000372",
            technical_code: {
                units: 5.0,
                code: "31000037",
                provenance: ""
            },
            procedure: {
                evidence: {
                    type: "MAPPING"
                },
                procedure_id: null,
                confidence: 0.9900000000000001,
                threashold: 0.9900000000000001,
                automate: true,
                used: false,
                procedure_name: "",
                procedure_code: 70450,
                type: "cpt",
                units: 5.0
            },
            modifiers: [
                {
                    evidence: {
                        type: "MAPPING"
                    },
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    used: false,
                    modifier_code: "LT"
                },
                {
                    evidence: {
                        type: "MAPPING"
                    },
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    used: false,
                    modifier_code: "GC"
                },
                {
                    evidence: {
                        type: "MAPPING"
                    },
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    used: false,
                    modifier_code: "26"
                }
            ],
            diagnoses: [
                {
                    evidence: [],
                    used: false,
                    type: null,
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    diagnosis_code: "R16.0"
                },
                {
                    evidence: [],
                    used: false,
                    type: null,
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    diagnosis_code: "R98.1"
                }
            ]
        },
        {
            type: "SUBMITTED",
            guid: "transaction guid here",
            transaction_type: "CHARGE",
            transaction_id: "CMX-MGPO-Billing-3",
            transaction_code: "1003001052088346",
            transaction_batch_id: "CMX-MGPO-Billing-3",
            transaction_posting_date: "2020-02-20T18:44:05.161-0500",
            transaction_description: "C4d Complement (immunofluorescence) - BW",
            alt_transaction_description: "",
            department_code: "10030010520",
            fee_schedule: "5000372",
            technical_code: {
                units: 5.0,
                code: "31000038",
                provenance: ""
            }
        }
    ],
    billing_provider_type: null,
    ordering_provider_type: null,
    referring_provider_type: null,
    performing_provider_type: null
};
exports.secondInvoice = {
    type: "assembled",
    guid: "invoice guid here",
    date_of_service: "2019-02-12",
    datetime_of_service: "2019-02-12T18:44:05.161-0500",
    point_of_care: "",
    place_of_service: "CMX Radiology-500 Main St",
    billing_location: "Outpatient",
    billing_area: "CMX IMAGING",
    billing_provider_specialty: "Radiology",
    billing_provider_name: "HELMAND MD, SUSAN V",
    billing_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    billing_provider_assistant_name: "Resident, Some",
    billing_provider_assistant_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    ordering_provider_name: "HAMILTON MD,GEORGE",
    ordering_provider_specialty: "Family Medicine",
    ordering_provider_number: {
        number: "45670",
        issuer: "EPIC",
        type: "UPN"
    },
    referring_provider_specialty: "Radiology",
    referring_provider_name: "HELMAND MD,SUSAN V",
    referring_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    rendering_provider_specialty: "Radiology",
    rendering_provider_name: "HELMAND MD,SUSAN V",
    rendering_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    performing_provider_specialty: "Radiology",
    performing_provider_name: "HELMAND MD,SUSAN V",
    performing_provider_number: {
        number: "15950",
        issuer: "EPIC",
        type: "UPN"
    },
    transactions: [
        {
            type: "SUBMITTED",
            guid: "transaction guid here",
            transaction_type: "CHARGE",
            transaction_id: "CMX-MGPO-Billing-4",
            transaction_code: "1003001052088346",
            transaction_batch_id: "CMX-MGPO-Billing-4",
            transaction_posting_date: "2020-02-20T18:44:05.161-0500",
            transaction_description: "C4d Complement (immunofluorescence) - BW",
            alt_transaction_description: "",
            department_code: "10030010520",
            fee_schedule: "5000372",
            technical_code: {
                units: 5.0,
                code: "31000037",
                provenance: ""
            },
            procedure: {
                evidence: [
                    {
                        type: "Ngram",
                        score: 0.05933449646073027,
                        feature: {
                            slop: 0,
                            field: "raw_body",
                            in_order: true,
                            ngram: "infraren",
                            type: "ngram",
                            spans: [
                                {
                                    start: 664,
                                    end: 674,
                                    level: "ngram",
                                    content: "infrarenal"
                                },
                                {
                                    start: 636,
                                    end: 818,
                                    level: "sentence",
                                    content: " The patient is status post infrarenal abdominal aortic endograft placement, with the proximal attachment at the suprarenal level, and distal  within the left common iliac artery. \n "
                                },
                                {
                                    start: 844,
                                    end: 922,
                                    level: "sentence",
                                    content: " The patient is status post infrarenal abdominal aortic endograft placement, with the proximal attachment at the suprarenal level, and distal  within the left common iliac artery. \n "
                                }
                            ]
                        }
                    }
                ],
                procedure_id: null,
                confidence: 0.9900000000000001,
                threashold: 0.9900000000000001,
                automate: true,
                used: false,
                procedure_name: "",
                procedure_code: 70450,
                type: "cpt",
                units: 5.0
            },
            modifiers: [
                {
                    evidence: {
                        type: "MAPPING"
                    },
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    used: false,
                    modifier_code: "LT"
                },
                {
                    evidence: {
                        type: "MAPPING"
                    },
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    used: false,
                    modifier_code: "26"
                }
            ],
            diagnoses: [
                {
                    evidence: [],
                    used: false,
                    type: null,
                    confidence: 0.9900000000000001,
                    threashold: 0.9900000000000001,
                    automate: true,
                    diagnosis_code: "R16.0"
                }
            ]
        }
    ],
    billing_provider_type: null,
    ordering_provider_type: null,
    referring_provider_type: null,
    performing_provider_type: null
};
var _invoiceWrapper = {
    cancelled: false,
    tenantId: { uuid: "BB1EA38B-7AB4-4498-A0B2-E2FD3CB029A4" },
    healthSystemTenantId: { uuid: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59" },
    guid: { uuid: "613ad98a-cb89-4b01-abd7-d37f72d63dc9" },
    serviceLine: "RADIOLOGY"
};
exports.basicInvoiceResponse = __assign(__assign({}, _invoiceWrapper), { status: "SUBMITTED", invoices: [exports.basicInvoice], caseType: "PLAYGROUND" });
exports.secondInvoiceResponse = __assign(__assign({}, _invoiceWrapper), { status: "SUBMITTED", invoices: [exports.secondInvoice], caseType: "PLAYGROUND" });
//# sourceMappingURL=basic-invoice.js.map